import { JSX } from "preact";

interface TextareaFieldProps
  extends JSX.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  name?: string; // Explicitly allow name (used in htmlFor and textarea)
  rows?: number; // Explicitly allow rows
  cols?: number; // Explicitly allow cols
}

export function TextareaField(props: TextareaFieldProps) {
  return (
    <div class="field">
      {props.label && (
        <label htmlFor={`field-${props.name}`}>{props.label}</label>
      )}
      <textarea
        id={`field-${props.name}`}
        autoComplete={props.autoComplete || "off"}
        {...props}
      />
    </div>
  );
}
